<template>
  <div class="xscontainer">
    <div class="mkd">
      <div class="nwerwer">
        <div class="xzzf">选择支付方式</div>
        <div class="ijwere">
          <div class="knkkd">
            <div class="uwuerer"><img class="rmbcss" src="@/assets/xxkc/rmb.png"></div>
            <div class="jinee">1000</div>
          </div>
          <div class="kndft">1000元/人/期</div>
        </div>
      </div>
      <div class="nnkdf3e">
        <p class="biaoti4_blue">线上支付</p>
        <div class="kkdf">
          <div class="iiwere">支付宝支付</div>
          <div class="iiwere1">微信支付</div>
        </div>
        <div class="lkdfkfd">
          <p class="kkkdfd">应付金额：</p>
          <p class="kkkdf">2880.00元</p>
        </div>
        <div class="hhffdffd">
          <div class="kkkdfd">实付金额：</div>
          <div class="sfu">1000.00</div>
          <div class="kkkdfd">元</div>
        </div>
        <div class="kwerwetw">立即支付</div>
        <div class="nuuwer">
          <img  class="kksdlfd" src="@/assets/xxkc/erweima.png">
          <div class="o3o454">
            <p class="zfuert">打开手机支付宝</p>
            <p class="zfuert">扫一扫继续支付</p>
          </div>
          <img  class="kndf" src="@/assets/xxkc/smzf.png">
        </div>

        <div class="xxzff">
          <p class="biaoti4_blue">线下支付</p>
          <p class="zhengwen_grey">请按照指引将参训费用转账至如下账户：</p>
          <p class="zhengwen_grey">银行：XXX</p>
          <p class="zhengwen_grey">账户：XXX</p>
          <p class="zhengwen_grey">备注：学员姓名或所在单位名称+联系方式</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  }
};
</script>


<style scoped>
.mkd{
  display: flex;
  gap: 3rem;
}
.nwerwer{
  display: flex;
  flex-direction: column;
  gap:1rem;

}
.ijwere{
  height: 10rem;
  width: 15rem;
  border: 2px solid #0f7cf1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.xzzf{
  font-weight: bold;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}
.knkkd{
  display: flex;
  align-items: center;
  justify-content: center;
}
.rmbcss{
  width: 1rem;
  height: 1rem;
}
.kndft{
  font-size: 18px;
  letter-spacing: 4px;
  margin-left: 1.5rem;
}
.uwuerer{
  display: flex;
  justify-content: start;
  height: 3rem;
}
.jinee{
  font-size: 50px;
  font-weight: bold;
  color: #0f7cf1;
}
.nnkdf3e{
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 3.5rem;
}
.kkdf{
  display: flex;
  gap: 1rem;
}
.iiwere{
  width: 150px;
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  color: black;
  background-color: white;
  border: 1px solid #0f7cf1;
  position: relative;
  text-align: center;
}
.iiwere1{
  width: 150px;
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  color: black;
  background-color: white;
  border: 1px solid #b5b3b3;
  position: relative;
  text-align: center;
}
.iiwere::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  background-color: #0f7cf1;
}
.lkdfkfd{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 1rem;
}
.hhffdffd{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.kkkdfd{
  line-height: 2rem;
  font-size: 16px;
  color: black;
}
.kkkdf{
  line-height: 2rem;
  font-size: 16px;
  color: #8a8a8a;
}
.sfu{
  line-height: 2rem;
  font-size: 30px;
  font-weight: bold;
  color: #0f7cf1;
  margin-right: 5px;
}
.kwerwetw{
  height: 3rem;
  width: 10rem;
  background-color: #0f7cf1;
  color: #ffffff;
  border-radius: 1.5rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 1rem;
}
.xxzff{
  margin-top: 3rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.nuuwer{
  margin-top: 3rem;
  width: 30rem;
  height: 15rem;
  border:1px solid #c6c6c6;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.kndf{
  width: 3rem;
  height: 3rem;
}
.kksdlfd{
  width: 10rem;
  height: 10rem;
}
.o3o454{
  display: flex;
  flex-direction: column;
}
.zfuert{
  font-weight: bold;
  font-size: 16px;
  color: #c6c6c6;
  letter-spacing: 2px;
}
</style>
